module.exports = __webpack_public_path__ + "static/media/energy7.54eed246.png";